import { QueryFunctionContext } from "@tanstack/react-query";
import { Client, mapUrl } from "../client";
import { Controller } from "../controller";
import { InteractionDto, VoicemailOverviewDto } from "../models";
import { Endpoint } from "..";
import { AssignInteractionRequest } from "../models/assignInteraction";
import { TransferDestination, TransferDestinationType } from "@/components/organisms/interactionTransferToIvr/types";
import { getColdTransferToIvrDestinations } from "./transferToIvr";
import { TransferStartResponse } from "@/common/types";

export const voicemailOverviewKey = "voicemailOverview";

export const fetchVoicemailsFn = (_: QueryFunctionContext) => {
	return Client.instance.get<InteractionDto[]>(Controller.Voicemails);
};

export const pickUpVoicemail = (id: string): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Voicemails, id, Endpoint.PickUp)
	);
};

export const assignVoicemail = (data: AssignInteractionRequest): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Voicemails, data.interactionId, Endpoint.Assign),
		data
	);
};

export const deleteVoicemail = (id: string): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Voicemails, id, Endpoint.Deleted)
	);
};

export const handleVoicemail = (
	id: string,
	isHandled: boolean
): Promise<any> => {
	return Client.instance.post(
		mapUrl(Controller.Voicemails, id, Endpoint.Handled),
		isHandled
	);
};

export const getVoicemailOverview = (id: string): Promise<VoicemailOverviewDto> => {
	return Client.instance.get<VoicemailOverviewDto>(
		mapUrl(Controller.History, Endpoint.Voicemails, id)
	);
};

export const transferVoicemail = (id: string, targetAgentUpn: string): Promise<TransferStartResponse> => {
	return Client.instance.post<TransferStartResponse>(
		mapUrl(Controller.Voicemails, id, Endpoint.VoicemailTransfer),
		targetAgentUpn
	);
};

export const transferVoicemailToQueue = (id: string, targetQueueId: string): Promise<boolean> => {
	return Client.instance.post<boolean>(
		mapUrl(Controller.Voicemails, id, Endpoint.VoicemailTransferToQueue),
		targetQueueId
	);
};

export const getVoicemailTransferDestinations = (): Promise<TransferDestination[]> =>
	getColdTransferToIvrDestinations().then((destinations) =>
		destinations.filter((d) => d.type === TransferDestinationType.Queue)
	);
